import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import { Icon, InlineIcon } from "@iconify/react";
import arrowExpandRight from "@iconify/icons-mdi/arrow-expand-right";
import Sidebar from "react-sidebar";
const { REACT_APP_URI = "/" } = process.env;

class ProposalInfo extends Component {
  state = {
    sidebarOpen: true,
  };
  onSetSidebarOpen = (open) => {
    this.setState({ sidebarOpen: open });
  };
  renderToggleButton = (direction) => {
    return (
      <ToggleButton
        isFixed={direction === "open"}
        onClick={() =>
          this.onSetSidebarOpen(direction === "open" ? true : false)
        }
      >
        <IconButton>
          <Icon
            width="20px"
            icon={arrowExpandRight}
            color={direction === "open" ? "#666" : "#fff"}
            rotate={direction === "open" ? "180deg" : "0"}
          />
        </IconButton>
      </ToggleButton>
    );
  };
  render() {
    const {
      state: { sidebarOpen },
      props: { classes, messages },
      renderToggleButton,
      onSetSidebarOpen,
    } = this;
    const fakeData = {
      id: 1,
      title: "提案名稱",
      company: 1,
      channels: [
        {
          id: 1,
          title: "頻道一",
          channelId: "xxzc_xcA",
          avatar: "avatar.png",
        },
        {
          id: 5,
          title: "頻道五",
          channelId: "xxzc_sdfA",
          avatar: "avatars.png",
        },
        {
          id: 9,
          title: "頻道9",
          channelId: "xxzaa_A",
          avatar: "avatard.png",
        },
      ],
      myProposalOrNot: true,
      fields: 1111111,
      sortCategory: "subscriberCount",
      sortRule: "descending",
      currentPermission: 2,
      publicDueTime: "2019-01-11 17",
      extendFields: [
        {
          name: "負責人",
          type: "STRING-SINGLE-SELECT",
          value: "frog",
        },
        {
          name: "客戶名稱",
          type: "STRING",
          value: "nissan",
        },
      ],
    };
    return (
      <React.Fragment>
        <Sidebar
          sidebar={
            <SidebarWrap>
              <SidebarNav>
                {renderToggleButton("close")}
                提案資訊
              </SidebarNav>
              <SidebarContainer>
                <TopField>
                  {[
                    "id",
                    fakeData.id,
                    "創建者",
                    "Frog",
                    "創建日期",
                    fakeData.publicDueTime,
                    "上次修改",
                    "還沒有",
                  ].map((i) => (
                    <div>{i}</div>
                  ))}
                </TopField>
                <Paper className={classes.root} elevation={1}>
                  <InputBase
                    className={classes.input}
                    // placeholder={placeholder}
                    // onInput={keywordInput}
                    // onKeyPress={e =>
                    //     e.key === "Enter" && keywordSubmit()
                    // }
                    // value={keyword}
                    type="text"
                  />
                </Paper>
              </SidebarContainer>
            </SidebarWrap>
          }
          open={sidebarOpen}
          onSetOpen={this.onSetSidebarOpen}
          pullRight={true}
          styles={{
            root: { pointerEvents: sidebarOpen ? "auto" : "none" },
            sidebar: { background: "white", zIndex: 20001 },
            overlay: { zIndex: 20000 },
          }}
        ></Sidebar>
        {renderToggleButton("open")}
      </React.Fragment>
    );
  }
}
const styles = {
  root: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    border: "1px solid #ccc",
    boxShadow: "none",
    padding: "0 0 0 10px",
    "@media (max-width: 665px)": {
      fontSize: "16px",
    },
  },
  input: {
    flex: 1,
    color: "#979797",
    fontSize: "14px",
    fontWeight: "300",
    "@media (max-width: 665px)": {
      fontSize: "16px",
    },
  },
  iconButton: {
    padding: 6,
  },
};
ProposalInfo.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
  return {
    user: state.User,
    messages: state.Messages,
  };
};
export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(ProposalInfo))
);

const ToggleButton = styled.div`
  position: ${({ isFixed }) => isFixed && "fixed"};
  top: 72px;
  right: 0;
  display: flex;
  color: #fff;
  z-index: 20000;
`;
const SidebarWrap = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  min-width: 400px;
`;
const SidebarNav = styled.div`
  display: flex;
  align-items: center;
  padding: 5px;
  font-size: 20px;
  color: #fff;
  background-color: #de0606;
`;
const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`;
const TopField = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #666;
`;



// WEBPACK FOOTER //
// ./src/Proposal/ProposalInfo.js